import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar, Toast, Dialog, Skeleton, List, Cell, Empty, Search, Tag, ActionSheet, Button } from 'react-vant';
import { ArrowLeft, Edit, DeleteO, Plus, LocationO, ManagerO } from '@react-vant/icons';
import { getClubs, deleteClub } from '../../../api/club';

const AdminClubs = () => {
  const navigate = useNavigate();
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  
  useEffect(() => {
    fetchClubs();
  }, []);

  const fetchClubs = async (search = '') => {
    try {
      setLoading(true);
      const res = await getClubs({ page: 1, page_size: 200, search });
      setClubs(res.items || []);
    } catch (error) {
      Toast.fail('获取社团列表失败');
    } finally {
      setLoading(false);
    }
  };

  const onSearch = (val) => {
    setSearchText(val);
    fetchClubs(val);
  };

  const handleDelete = (id, name) => {
    Dialog.confirm({
      title: '删除确认',
      message: `确定要删除社团【${name}】吗？这将同时删除该社团下的所有报名批次和记录。`,
      onConfirm: async () => {
        try {
          await deleteClub(id);
          Toast.success('删除成功');
          fetchClubs(searchText);
        } catch (error) {
          Toast.fail('删除失败: ' + (error.response?.data?.detail || '存在关联数据'));
        }
      }
    });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', paddingBottom: '80px' }}>
      <NavBar 
        title={<span style={{ fontWeight: 800 }}>社团库管理</span>} 
        leftText={<ArrowLeft size={20} />} 
        onClickLeft={() => navigate(-1)}
        fixed
        placeholder
      />

      <Search
        value={searchText}
        onChange={setSearchText}
        onSearch={onSearch}
        onClear={() => onSearch('')}
        placeholder="搜索社团名称、教师或地点"
        style={{ background: '#fff' }}
      />

      <div style={{ padding: '12px' }}>
        {loading ? (
          <Skeleton title row={10} />
        ) : clubs.length === 0 ? (
          <Empty description="暂无社团数据" />
        ) : (
          clubs.map(club => (
            <div 
              key={club.id}
              style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.02)',
                border: club.status === 'inactive' ? '1px dashed #cbd5e1' : 'none'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <span style={{ fontSize: '17px', fontWeight: 800, color: '#0f172a' }}>{club.name}</span>
                    <Tag type={club.status === 'active' ? 'success' : 'default'} plain size="medium">
                      {club.status === 'active' ? '活跃' : '停用'}
                    </Tag>
                  </div>
                  <div style={{ fontSize: '12px', color: '#94a3b8' }}>{club.category}</div>
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                   <Edit size={20} color="#056b4f" onClick={() => navigate(`/clubs/admin/club-edit/${club.id}`)} />
                   <DeleteO size={20} color="#e11d48" onClick={() => handleDelete(club.id, club.name)} />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#64748b' }}>
                  <ManagerO size={14} color="#94a3b8" />
                  <span>{club.instructor_name}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#64748b' }}>
                  <LocationO size={14} color="#94a3b8" />
                  <span>{club.venue || '未定地点'}</span>
                </div>
              </div>

              {club.grade_range && (
                <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {club.grade_range.map(g => (
                    <Tag key={g} size="mini" round color="#f0fdf4" textColor="#056b4f" border={false}>
                      {g}
                    </Tag>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>

      <div style={{ position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', width: '90%', maxWidth: '400px' }}>
        <Button 
          type="primary" 
          block 
          round 
          icon={<Plus />}
          onClick={() => navigate('/clubs/admin/club-edit/new')}
          style={{ boxShadow: '0 4px 16px rgba(5, 107, 79, 0.3)' }}
        >
          创建新社团
        </Button>
      </div>
    </div>
  );
};

export default AdminClubs;
